export default __webpack_public_path__ + "static/media/join-battle.1949bc31.svg";